import { MARKETS, IMAGES } from "@/lib/site-data";
import { CheckCircle2, Globe, Ship, Truck } from "lucide-react";

export default function Markets() {
  return (
    <div>
      <section className="bg-sky-50/60 py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold tracking-widest text-[#1e5ba8]">MARKETS</p>
          <h1 className="font-display font-bold text-5xl sm:text-6xl text-[#0f172a] mt-3 tracking-tight">Delivering Freshness Across the Globe</h1>
          <p className="text-slate-600 mt-4 max-w-2xl">We proudly export to 30+ countries with reliable logistics partners across sea and land routes.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <img src={IMAGES.truck} alt="Global logistics" className="rounded-2xl w-full h-[400px] object-cover shadow-lg" />
          <div>
            <h2 className="font-display font-bold text-3xl text-[#0f172a]">Our Global Reach</h2>
            <p className="text-slate-600 mt-3">We serve buyers across:</p>
            <ul className="mt-5 grid grid-cols-2 gap-3">
              {MARKETS.map((m) => (
                <li key={m} className="flex items-center gap-2 text-slate-700">
                  <CheckCircle2 className="w-4 h-4 text-[#1e5ba8]" /> {m}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-slate-50/70 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-6">
          {[
            { icon: Globe, title: "30+ Countries", desc: "Active export partners across continents." },
            { icon: Ship, title: "Sea Freight", desc: "Reefer container shipping to global ports." },
            { icon: Truck, title: "Land Logistics", desc: "Reliable road logistics to inland markets." },
          ].map((c) => (
            <div key={c.title} className="bg-white p-6 rounded-xl border border-slate-200">
              <div className="w-12 h-12 rounded-md bg-[#1e5ba8] text-white flex items-center justify-center">
                <c.icon className="w-6 h-6" />
              </div>
              <div className="font-display font-bold text-lg mt-4">{c.title}</div>
              <div className="text-sm text-slate-600 mt-2">{c.desc}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
